import { Injectable, InjectionToken, inject } from '@angular/core';
import { Storage } from './model/storage.model';

export const UI_STORAGE = new InjectionToken<Storage>('UI_STORAGE');

@Injectable({
  providedIn: 'root',
})
export class StorageService implements Storage {
  private readonly storage = inject<Storage>(UI_STORAGE);

  get(key: string): Promise<string | null> {
    return this.storage.get(key);
  }

  has(key: string): Promise<boolean> {
    return this.storage.has(key);
  }

  remove(key: string): Promise<boolean> {
    return this.storage.remove(key);
  }

  set(key: string, data: string): Promise<boolean> {
    return this.storage.set(key, data);
  }

  getKeys(): Promise<string[]> {
    return this.storage.getKeys();
  }
}
